export default __webpack_public_path__ + "static/media/magnifier.69d8054b.png";